import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloadapp',
  templateUrl: './downloadapp.component.html',
  styleUrls: ['./downloadapp.component.scss']
})
export class DownloadappComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
